import {
  AreaItemType,
  ConditionField,
  DimensionDescriptor,
  DimensionField,
  DimensionFieldType,
  FieldConfiguration,
  FieldConfigurationType,
  MeasureDescriptor,
  MeasureField,
  MetricDescriptor,
  MetricField,
  ReportField,
  TileConfiguration,
  TileSettings,
} from "../../../../../shared/reporting/api/biClient.types";
import { tileSettingsSchema } from "../../../../../shared/reporting/api/biClientSchema";
import { isAggregatedType } from "../../../../../shared/reporting/utils/fieldsHelper";

export const createTileReportConfiguration = (
  conditions: ConditionField[],
  fields: ReportField[],
  settings: TileSettings
) => {
  const reportConfiguration: TileConfiguration = {
    conditions: conditions.map((c) => c.config),
    fields: fields.map((field) => field.config),
    settings: { ...settings },
  };
  return reportConfiguration;
};

export const configurationToTileFields = (
  configs: FieldConfiguration[],
  dimensions: DimensionDescriptor[],
  measures: MeasureDescriptor[],
  metrics: MetricDescriptor[]
) => {
  try {
    const tableFields = configs
      .map((config) => {
        if (isAggregatedType(config)) {
          const dimensionMeta = dimensions.find((d) => d.name === config.name);
          if (dimensionMeta) {
            return <DimensionField>{
              type: DimensionFieldType.DIMENSION,
              meta: dimensionMeta,
              config,
              areaItemType: AreaItemType.FIELDS,
            };
          } else {
            //eslint-disable-next-line no-console
            console.log(`Field ${config.name} is not found in the dimensions' list`);
            return undefined;
          }
        }
        if (config.type === FieldConfigurationType.Measure || config.type === FieldConfigurationType.Irr) {
          const measure = measures.find((m) => m.name === config.name);
          if (measure) {
            return <MeasureField>{
              type: DimensionFieldType.MEASURE,
              meta: measure,
              areaItemType: AreaItemType.FIELDS,
              config,
            };
          } else {
            //eslint-disable-next-line no-console
            console.log(`Measure ${config.name} is not found in the measures' list`);
            return undefined;
          }
        }
        if (config.type === FieldConfigurationType.Metric) {
          const metric = metrics.find((m) => m.name === config.name);
          if (metric) {
            return <MetricField>{
              type: DimensionFieldType.METRIC,
              meta: metric,
              areaItemType: AreaItemType.FIELDS,
              config,
            };
          } else {
            //eslint-disable-next-line no-console
            console.log(`Metric ${config.name} is not found in the metrics' list`);
            return undefined;
          }
        }
        return undefined;
      })
      .filter((field): field is ReportField => !!field);
    return tableFields;
  } catch {
    return [];
  }
};

export const configurationToTileSettings = (settings: TileSettings) => {
  return tileSettingsSchema.parse(settings);
};
